'use strict'

import { Model } from '@vuex-orm/core'

export default class ExecutorContact extends Model {
  static get entity () { return 'executorContacts' }
  static get primaryKey () { return ['willId', 'contactId'] }

  static fields () {
    return {
      willId: this.attr(null),
      contactId: this.attr(null)
    }
  }
}
